<template>
  <zg-sticky-table-of-contents
    :items="items"
    :highlighted-id="highlightedId"
    @clickItem="scrollToItem"
  />
</template>

<script>
import { ZgStickyTableOfContents } from '@zc/components/ZgStickyTableOfContents'
import { getUrlSearchParams } from '../utils'

export default {
  name: 'StickyTableOfContents',
  components: {
    ZgStickyTableOfContents
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
      validate: items => items.every(item => item?.text && item.id)
    }
  },
  data () {
    return {
      highlightedId: '',
      observer: null
    }
  },
  mounted () {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id')
            this.highlightedId = id
          }
        })
      }, { root: null, rootMargin: '-50%' })

      this.items.forEach(item => {
        const elem = document.getElementById(item.id)
        if (elem) {
          this.observer.observe(elem)
        }
      })
    }

    const scrollTo = getUrlSearchParams()?.['scroll-to']
    if (scrollTo) this.scrollToItem({ id: scrollTo })
  },
  beforeDestroy () {
    this.observer?.disconnect()
  },
  methods: {
    scrollToItem (item) {
      this.$scrollTo(`[id="${item.id}"]`, {
        offset: -110, // -(header + stoc + section padding)
        onDone: () => {
          this.highlightedId = item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .zg-stoc {
    display: none;

    @include mq(large) {
      display: flex;
      position: fixed;
      top: rem(56);
      z-index: 10;
    }
  }
</style>
